import { createRouter, createWebHistory } from "vue-router";

// Import pages here
import index from "./views/index.vue";
import signal from "./views/signal.vue";
import notFound from "./views/notFound.vue";
// extra pages here
import extraIndex from "./views/extraIndex.vue";
import fursonaRef from "./views/fursonaRef.vue";
import crypto from "./views/crypto.vue";
import aboutblank from "./views/aboutblank.vue";
import browserInfo from "./views/browserInfo.vue";
import urlopen from "./views/urlopen.vue";
import cryptoqr from "./views/cryptoqr.vue";

const routes = [
  // system pages
  { path: "/", component: index, meta: { title: 'Welcome to SamJ.App' } },
  { path: "/signal", component: signal, meta: { title: 'Signal | SamJ.App' } },
  // extra pages
  { path: "/extra", component: extraIndex, meta: { title: 'Extra Index | SamJ.App' } },
  { path: "/extra/index", component: extraIndex, meta: { title: 'Extra Index | SamJ.App' } },
  { path: "/extra/fursona-ref", component: fursonaRef, meta: { title: 'Fursona Reference | 3kh0' } },
  { path: "/extra/crypto", component: crypto, meta: { title: 'Crypto Wallets | SamJ.App' } },
  { path: "/extra/aboutblank", component: aboutblank, meta: { title: 'about:blank embedder | SamJ.App' } },
  { path: "/extra/browserinfo", component: browserInfo, meta: { title: 'What is my IP? | SamJ.App' } },
  { path: "/extra/urlopen", component: urlopen, meta: { title: 'URL Opener | SamJ.App' } },
  { path: "/extra/cryptoqr", component: cryptoqr, meta: { title: 'Crypto QR Code Generator | SamJ.App' } },
  // catch-all route
  { path: "/:pathMatch(.*)*", component: notFound, meta: { title: '404 Error | SamJ.App' } },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.afterEach((to) => {
  document.title = to.meta.title || 'Default Title';
})

export default router;
